import { Link } from "react-router-dom";
import "../Services.css";
import { useState } from "react";

const FAQSection = () => {
  const faqs = [
    {
      question: "1. On which Zoho applications do you provide implementation and training?",
      answer:
        "We provide complete implementation and training support for Zoho Books, Zoho Payroll, and Zoho Inventory.",
    },
    {
      question: "2. Can you help us migrate from Tally, QuickBooks, or Excel to Zoho Books?",
      answer:
        "Absolutely. We offer seamless migration services from Tally, QuickBooks, Xero, and Excel spreadsheets to Zoho Books—ensuring zero data loss, accurate mapping, and smooth transition with full continuity of your accounting records.",
    },
    {
      question: "3. Do you provide ongoing support after Zoho Books and Zoho Payroll setup?",
      answer:
        "Yes. We offer monthly or quarterly advisory support, which includes reviewing accounting entries, payroll processing, reconciliations and more. We’re committed to being your long-term Zoho advisory partner.",
    },
    {
      question: "4. How do you support companies with remote or global teams?",
      answer:[
         "Zoho is fully cloud-based, making it perfect for remote-first or globally distributed teams. We assist in setting up role-based access and multi-currency handling and ensure smooth collaboration across geographies.",
      ].join('\n')
       
    },
  ];

  const [openIdx, setOpenIdx] = useState(null);
  const toggle = (idx) => setOpenIdx((prev) => (prev === idx ? null : idx));

  return (
    <div className="faq-section py-5">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="section-title1">Zoho Advisory FAQs</h2>
          <Link to="/pricing" className="see-plan-link">
            See Plan &rarr;
          </Link>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="faq-accordion">
              {faqs.map((faq, index) => {
                const isOpen = openIdx === index;
                const isString = typeof faq.answer === 'string';
                return (
                  <div className="faq-item" key={index}>
                    <button
                      type="button"
                      className="faq-toggle"
                      aria-expanded={isOpen}
                      aria-controls={`faq-content-${index}`}
                      onClick={() => toggle(index)}
                    >
                      <h5 className="faq-question m-0">{faq.question}</h5>
                      <span className="faq-icon" aria-hidden>{isOpen ? '−' : '+'}</span>
                    </button>
                    <div
                      id={`faq-content-${index}`}
                      className={`faq-content ${isOpen ? 'open' : ''}`}
                      role="region"
                    >
                      <div className="faq-content-inner">
                        {isString ? (
                          <p className="faq-answer" style={{ whiteSpace: 'pre-line', marginBottom: 0 }}>{faq.answer}</p>
                        ) : (
                          <div className="faq-answer">{faq.answer}</div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;

